import React, { useState, useEffect, Fragment } from 'react';
import { getProjectEconomicFrameworksOverview } from '@lib/api';
import { formatToDecimals } from 'lib/helpers/formatting';

const BudgetOverview = ({ projectId, isCashflow }) => {
	const [generalOverview, setGeneralOverview] = useState({});
	const [overview, setOverview] = useState([]);

	const groupByCompanyAndSumTotals = (data, isCashflow) => {
		const result = [];
		data.forEach((item) => {
			const { companyId, companyName, projectStreamId, projectStreamName, monthlyData, streamId } = item;
			let company = result.find((c) => c.companyId === companyId);

			if (!company) {
				company = {
					companyId,
					companyName,
					wp: [],
				};
				result.push(company);
			}

			const totalByWp = monthlyData.reduce((acc, month) => acc + (isCashflow ? month.cashedTotal : month.total), 0);

			company.wp.push({
				projectStreamId,
				projectStreamName,
				totalByWp,
				streamId,
			});
		});

		return result;
	};

	useEffect(() => {
		if (projectId) {
			getProjectEconomicFrameworksOverview(projectId).then((retrievedOverview) => {
				if (retrievedOverview.success) {
					const { budgets, ...restOverview } = retrievedOverview.data;
					setGeneralOverview(restOverview);

					setOverview(groupByCompanyAndSumTotals(retrievedOverview.data.budgets, isCashflow));
				}
			});
		}
	}, [projectId, isCashflow]);

	const rowOverview = () => {
		return overview.map((company, index) => {
			return (
				<Fragment key={index}>
					<tr className="mb-3">
						<td>
							<span>{company.companyName}</span>
						</td>
						<td></td>
						<td></td>
					</tr>
					{company.wp.map((wp, index) => {
						return (
							<tr key={index}>
								<td></td>
								<td>
									<span>
										{wp.streamId} - {wp.projectStreamName}
									</span>
								</td>
								<td className="text-end">
									<span>{formatToDecimals(wp.totalByWp ? wp.totalByWp : 0)}</span>
								</td>
							</tr>
						);
					})}
				</Fragment>
			);
		});
	};

	return (
		<>
			{overview ? (
				<>
					<table id="overview-budget" style={{ borderSpacing: '10px', borderCollapse: 'separate' }}>
						<thead>
							<tr>
								<th>
									<h5>Società</h5>
								</th>
								<th>
									<h5>Work Package</h5>
								</th>
								<th style={{ textAlign: 'right' }}>
									<h5> {isCashflow ? 'Incasso (€)' : 'Budget (€)'}</h5>
								</th>
							</tr>
						</thead>
						<tbody>
							{rowOverview()}
							<tr>
								<th className="pt-3">
									<h5>TOTALE</h5>
								</th>
								<td></td>
								<th className="pt-3" style={{ textAlign: 'right' }}>
									<h5>{formatToDecimals(isCashflow ? (generalOverview.totalCashedBudget ?? 0) : (generalOverview.totalBudget ?? 0))}</h5>
								</th>
							</tr>
						</tbody>
					</table>
				</>
			) : null}
		</>
	);
};
export default BudgetOverview;
